import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

import { TranslocoService } from '@jsverse/transloco';

export const pageTitleResolverFactory =
  (key: string): ResolveFn<string> =>
  () => {
    const transloco = inject(TranslocoService);
    return transloco.selectTranslate(key);
  };
